"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7869],{

/***/ 75833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export pipeA */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const pipe = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>fn(val), value);
};
const pipeA = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>(0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(val) ? val.then(fn) : fn(val), value);
};
pipe.async = pipeA;
/* harmony default export */ __webpack_exports__["Z"] = (pipe);


/***/ }),

/***/ 69340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xD": function() { return /* reexport */ and; },
  "ZP": function() { return /* binding */ validation; },
  "jh": function() { return /* reexport */ validators/* isCorrectEmailLen */.jh; },
  "Jh": function() { return /* reexport */ validators/* isEmail */.Jh; },
  "QZ": function() { return /* reexport */ validators/* isSimpleEmail */.QZ; },
  "Y1": function() { return /* reexport */ validators/* isTheSame */.Y1; },
  "OO": function() { return /* reexport */ validators/* isZipCode */.OO; },
  "v_": function() { return /* reexport */ join; },
  "EQ": function() { return /* reexport */ validators/* match */.EQ; },
  "g3": function() { return /* reexport */ validators/* maxLen */.g3; },
  "bV": function() { return /* reexport */ validators/* minLen */.bV; },
  "ff": function() { return /* reexport */ not; },
  "C1": function() { return /* reexport */ validators/* required */.C1; },
  "jR": function() { return /* reexport */ rule; }
});

// UNUSED EXPORTS: EMAIL_ACCOUNT_LENGTH, EMAIL_LENGTH, EMAIL_PATTERN, SIMPLE_EMAIL_PATTERN, all, endsWith, greater, isDomainOrIp, isIP, isUUID, less, max, min, notEqualTo, notIn, oneOf, or, some, startsWith

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/rule.js
/**
 * Builds ValidationRuleFn from predicate and error message
 *
 * @typedef {import("./types").Predicate} Predicate
 * @typedef {import("./types").ValidationRuleFn} ValidationRuleFn
 * @type {(predicate: Predicate, message: string) => ValidationRuleFn}
 */ // eslint-disable-next-line react/display-name
const rule = (predicate, message)=>(value, form, fieldName)=>predicate(value, form, fieldName) ? null : message;

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/_helpers.js
const escapeRegExp = (text)=>text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
const skipEmpty = (reducer)=>(arg1, arg2)=>{
        if (arg1 != null && arg2 != null) return reducer(arg1, arg2);
        if (arg1 != null) return arg1;
        return arg2;
    };
const skipEmptyMapper = (mapper)=>(arg)=>arg != null ? mapper(arg) : arg;

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/_rule-binary-ops.js

// creates rule that checks if both rules are satisfied
const apply2 = (rule1, rule2)=>(value, form, fieldName)=>rule1(value, form, fieldName) || rule2(value, form, fieldName);
const _rule_binary_ops_and2Lazy = skipEmpty(apply2);
const pack = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return [].concat(...args);
};
const join2 = (rule1, rule2)=>(value, form, fieldName)=>{
        const res1 = rule1(value, form, fieldName);
        const res2 = rule2(value, form, fieldName);
        return res1 && res2 && pack(res1, res2) || res1 && pack(res1) || res2 && pack(res2);
    };
const join2Lazy = skipEmpty(join2);
const some2 = (rule1, rule2)=>(value, form, fieldName)=>{
        const res1 = rule1(value, form, fieldName);
        return res1 ? rule2(value, form, fieldName) : res1;
    };
const _rule_binary_ops_some2lazy = skipEmpty(some2);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/_prepare-rule.js


const _prepare_rule_all = function() {
    for(var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++){
        rules[_key] = arguments[_key];
    }
    return rules.reduce(_rule_binary_ops_and2Lazy);
};
const WRONG_PARAMS_MESSAGE = "Expected rule to have one of types: function, function[] or [function, string]";
const prepareRule = (ruleParam)=>{
    if (false) {}
    if (typeof ruleParam === "function") return ruleParam;
    if (false) {}
    if (ruleParam.length === 2) {
        const [predicate, message] = ruleParam;
        if (typeof predicate === "function" && typeof message === "string") {
            return rule(predicate, message);
        }
    }
    if (false) {}
    return _prepare_rule_all(...ruleParam.map(prepareRule));
};
/* harmony default export */ var _prepare_rule = (prepareRule);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/form-validator.js

const packNotEmpty = (field, error)=>error != null // if not empty
     ? {
        [field]: error
    } // pack to object with key equal field
     : null; // otherwise return null
const createFieldValidator = (param)=>{
    let [field, fieldRule] = param;
    const fieldValidator = _prepare_rule(fieldRule);
    return (form)=>packNotEmpty(field, fieldValidator(form[field], form, field));
};
const validationReducer = (form)=>(validationState, validator)=>{
        const fieldError = validator(form);
        // eslint-disable-next-line no-param-reassign
        Object.assign(validationState.errors, fieldError);
        // eslint-disable-next-line no-param-reassign
        validationState.isValid = validationState.isValid && fieldError == null;
        return validationState;
    };
/**
 * Creates `FormValidator` from array of field-validators.
 *
 * @typedef {import("./types").FieldValidator} FieldValidator
 * @typedef {import("./types").FormValidator} FormValidator
 * @type {(...validators: FieldValidator[]) => FormValidator}
 */ const validateFormWith = (validators)=>(form)=>validators.reduce(validationReducer(form), {
            isValid: true,
            errors: {}
        });
/**
 * Creates `FormValidator` from Validation Schema
 *
 * @typedef {import("./types").ValidationSchema} ValidationSchema
 * @typedef {import("./types").FormValidator} FormValidator
 * @type {(validationSchema: ValidationSchema) => FormValidator}
 */ const creteFormValidator = (validationSchema)=>validateFormWith(// creating an Array of form validators
    Object.entries(validationSchema).map(createFieldValidator));
/* harmony default export */ var form_validator = (creteFormValidator);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/rules.js





const makeRule = skipEmptyMapper(_prepare_rule);
/**
 * Builds new complex `ValidationRuleFn` from other `ValidationRuleFn`'s.
 *
 * New complex rule applies its subrules one by one until find error.
 *
 * @typedef {import("./types").ValidationRuleFn} ValidationRuleFn
 * @type {(...rules: ValidationRuleFn[]) => ValidationRuleFn}
 */ const rules_all = function() {
    for(var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++){
        rules[_key] = arguments[_key];
    }
    return rules.map(makeRule).reduce(and2Lazy);
};
/**
 * Builds new complex `ValidationRuleFn` from other `ValidationRuleFn`'s.
 *
 * New complex rule applies all its subrules one by one and packs all found
 * errors to the array
 *
 * @typedef {import("./types").ValidationRuleFn} ValidationRuleFn
 * @type {(...rules: ValidationRuleFn[]) => ValidationRuleFn}
 */ const join = function() {
    for(var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++){
        rules[_key] = arguments[_key];
    }
    return rules.map(makeRule).reduce(join2Lazy);
};
const some = function() {
    for(var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++){
        rules[_key] = arguments[_key];
    }
    return rules.map(makeRule).reduce(some2lazy);
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/validators.js
var validators = __webpack_require__(83540);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/predicates.js

/**
 * Creates Inversed Predicate
 *
 * @typedef {import("./types").Predicate} Predicate
 * @type {(predicate: Predicate): Predicate}
 */ const not = (predicate)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return !predicate(...args);
    };
const and2 = skipEmpty(// decoratorating with "skipEmpty"
(pred1, pred2)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return pred1(...args) && pred2(...args);
    });
/**
 * Creates new Predicate that returns true if all of argument predicates return true
 *
 * @typedef {import("./types").Predicate} Predicate
 * @type {(...predicates: Predicate[]): Predicate}
 */ const and = function() {
    for(var _len = arguments.length, predicates = new Array(_len), _key = 0; _key < _len; _key++){
        predicates[_key] = arguments[_key];
    }
    return predicates.reduce(and2);
};
const or2 = skipEmpty(// decoratorating with "skipEmpty"
(pred1, pred2)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return pred1(...args) || pred2(...args);
    });
/**
 * Creates new Predicate that returns true if at least one of argument predicates return true
 *
 * @typedef {import("./types").Predicate} Predicate
 * @type {(...predicates: Predicate[]): Predicate}
 */ const or = function() {
    for(var _len = arguments.length, predicates = new Array(_len), _key = 0; _key < _len; _key++){
        predicates[_key] = arguments[_key];
    }
    return predicates.reduce(or2);
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js




/* harmony default export */ var validation = (form_validator);


/***/ }),

/***/ 83540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "EQ": function() { return /* binding */ match; },
/* harmony export */   "Jh": function() { return /* binding */ isEmail; },
/* harmony export */   "OO": function() { return /* binding */ isZipCode; },
/* harmony export */   "QZ": function() { return /* binding */ isSimpleEmail; },
/* harmony export */   "Y1": function() { return /* binding */ isTheSame; },
/* harmony export */   "bV": function() { return /* binding */ minLen; },
/* harmony export */   "g3": function() { return /* binding */ maxLen; },
/* harmony export */   "jh": function() { return /* binding */ isCorrectEmailLen; },
/* harmony export */   "t": function() { return /* binding */ isUUID; }
/* harmony export */ });
/* unused harmony exports EMAIL_LENGTH, EMAIL_ACCOUNT_LENGTH, EMAIL_PATTERN, SIMPLE_EMAIL_PATTERN, isDomainOrIp, isIP, endsWith, startsWith, min, greater, max, less, notEqualTo, oneOf, notIn */
/* eslint-disable no-control-regex */ 
const EMAIL_LENGTH = 100;
const EMAIL_ACCOUNT_LENGTH = 64;
const EMAIL_PATTERN = /^[0-9_A-Za-z](?:\.?[-+_'0-9A-Za-z])*@(?:[a-zA-Z0-9]{1,2}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9])(?:\.(?:[a-zA-Z0-9]{1,2}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]))*\.[a-zA-Z]{2,}$/;
const SIMPLE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const required = (value)=>value != null && (typeof value !== "string" || value.trim() !== "");
const isAccount = (account)=>account.length <= 64 && /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")$/i.test(account);
const isDomainOrIp = (domain)=>/^(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i.test(domain);
const isIP = (ip)=>/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(ip);
// eslint-disable-next-line no-unused-vars
const validateEmailParts = (parts)=>{
    const [account, domain] = parts;
    return parts.length === 2 && Boolean(account) && Boolean(domain) && isAccount(account) && isDomainOrIp(domain);
};
const validateEmail = (regexRule, value)=>{
    const parts = value.split("@");
    const [account, domain] = parts;
    return parts.length === 2 && Boolean(account) && Boolean(domain) && value.length <= EMAIL_LENGTH && account.length <= EMAIL_ACCOUNT_LENGTH && regexRule.test(value);
};
const isEmail = (value)=>{
    return validateEmail(EMAIL_PATTERN, value);
};
const isSimpleEmail = (value)=>{
    return validateEmail(SIMPLE_EMAIL_PATTERN, value);
};
const isCorrectEmailLen = (len)=>(value)=>{
        const parts = value.split("@");
        // Validator responcibility is to check local-part length
        // and it takes place only if email composed correctly "localPart@domainName.zone"
        return parts.length === 2 ? parts[0].length <= len : true;
    };
const minLen = (len)=>(value)=>value.length >= len;
const maxLen = (len)=>(value)=>value.length <= len;
const match = (re)=>(value)=>re.test(value);
const endsWith = (tail)=>match(new RegExp("".concat(escapeRegExp(tail), "$")));
const startsWith = (head)=>match(new RegExp("^".concat(escapeRegExp(head))));
const min = (minValue)=>(value)=>value >= minValue;
const greater = (minValue)=>(value)=>value > minValue;
const max = (maxValue)=>(value)=>value <= maxValue;
const less = (maxValue)=>(value)=>value < maxValue;
const isTheSame = (otherFieldName)=>(value, form)=>value === form[otherFieldName];
const notEqualTo = function(text) {
    let caseSensitive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (value)=>caseSensitive ? value.toString() !== text.toString() : value.toString().toLowerCase() !== text.toString().toLowerCase();
};
const isZipCode = (countryID, value)=>{
    switch(countryID){
        case 220:
            return /^[0-9]{5}(?:-[0-9]{4})?$/.test(value);
        case 38:
            return /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/.test(value);
        case 224:
            return /^[A-Z]{1,2}[0-9R][0-9A-Z]? [0-9][ABD-HJLNP-UW-Z]{2}$/.test(value);
        default:
            return true;
    }
};
const oneOf = function(list) {
    let ignoreCase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const expected = new Set(ignoreCase ? list.map((value)=>value.toUpperCase()) : list);
    return (value)=>!value || expected.has(ignoreCase ? value.toUpperCase() : value);
};
const notIn = (list, ignoreCase)=>{
    const predicate = oneOf(list, ignoreCase);
    return (value)=>!(value && predicate(value));
};
const isUUID = (value)=>typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);


/***/ }),

/***/ 83803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports mapServerSideRedirectUrl, mapClientSideRedirectUrl, replaceUrl, redirectIf, redirectIfProps, redirectOnError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _insightfulscience_shared_utils_validation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69340);





/** @typedef {import("next").NextPageContext} NextPageContext */ /** @typedef {import("next").NextPage} NextPage */ /**
 * @typedef {[
 *  <A extends any[]>(context: NextPageContext, ...args: A) => boolean,
 *  string | (context: NextPageContext) => string | null | undefined
 * ]} PreCondition
 */ /**
 * @template {{}} P
 * @typedef {[
 *  <A extends any[]>(props: P, context: NextPageContext, ...args: A) => boolean,
 *  string | (props: P, context: NextPageContext) => string | null | undefined
 * ]} PostCondition
 */ /**
 * @typedef {[
 *  <E extends Error, A extends any[]>(err: E, context: NextPageContext, ...args: A) => boolean,
 *  string | <E extends Error>(error: E, context: NextPageContext) => string | null | undefined
 * ]} ErrorCondition
 */ /**
 * @template {{}} P
 * @typedef {import("next").NextPage<P> & {
 * 	preConditions?: PreCondition[];
 * 	postConditions?: PostCondition<P>[];
 *  onError?: ErrorCondition[];
 * }} ConditionalPage
 */ const hooks = {
    mapServerSideRedirect: (pathOrUrl)=>pathOrUrl,
    mapClientSideRedirect: (pathOrUrl)=>pathOrUrl
};
/** @type {(mapper: (pathOrUrl: string, context: import("next").NextPageContext) => string) => void} */ const mapServerSideRedirectUrl = (mapper)=>{
    hooks.mapServerSideRedirect = ensureFunc(mapper, (pathOrUrl)=>pathOrUrl);
};
/** @type {(mapper: (pathOrUrl: string, context: import("next").NextPageContext) => string) => void} */ const mapClientSideRedirectUrl = (mapper)=>{
    hooks.mapClientSideRedirect = ensureFunc(mapper, (pathOrUrl)=>pathOrUrl);
};
const serverReplaceUrl = (dest, context)=>{
    const { res  } = context;
    res.redirect(302, hooks.mapServerSideRedirect(dest, context));
    res.end();
    return {
        __dontRender: true
    };
};
const isUrlNotHasProtocol = (url)=>url.slice(0, 2) === "//";
const withProtocol = (url)=>isUrlNotHasProtocol(url) ? "".concat(window.location.protocol).concat(url) : url;
const clientReplaceUrl = (dest, context)=>{
    next_router__WEBPACK_IMPORTED_MODULE_2___default().push(hooks.mapClientSideRedirect(withProtocol(dest), context));
    return {
        __dontRender: true
    };
};
const replaceUrl = (/* unused pure expression or super */ null && ( false ? 0 : clientReplaceUrl));
const redirect = (dest, context, args)=>{
    const redirectHandler =  false ? 0 : clientReplaceUrl;
    return redirectHandler((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .Wl)(dest) ? dest(...args) : dest, context);
};
const safeApply = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .Wl)(fn) ? fn(...args) : {
        __dontRender: false
    };
};
const shouldRender = (value)=>{
    return !(value === null || value === void 0 ? void 0 : value.__dontRender);
}; // eslint-disable-line no-underscore-dangle
const createTransition = (param)=>{
    let [predicate, redirectTo] = param;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return shouldRender(...args) && predicate(...args) ? redirectTo : null;
    };
};
const composeTransitions = (t1, t2)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return t1(...args) || t2(...args);
    };
const createTransitions = (transitionRule)=>transitionRule.map(createTransition).reduce(composeTransitions);
const redirectIf = (transitionRules)=>{
    const transition = createTransitions(transitionRules);
    return (getInitialProps)=>function(context) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            const dest = transition(context, ...args);
            return dest ? redirect(dest, context, [
                context,
                ...args
            ]) : safeApply(getInitialProps, context, ...args);
        };
};
const redirectIfProps = (transitionRules)=>{
    const transition = createTransitions(transitionRules);
    return (getInitialProps)=>function(context) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            const applyRedirect = (props)=>{
                const transitionArgs = [
                    props,
                    context,
                    ...args
                ];
                const dest = transition(...transitionArgs);
                return dest // check redirect condition
                 ? redirect(dest, context, transitionArgs) : props;
            };
            const componentProps = safeApply(getInitialProps, context, ...args);
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isPromise */ .tI)(componentProps) ? componentProps.then(applyRedirect) : applyRedirect(componentProps);
        };
};
const redirectOnError = (transitionRules)=>{
    const transition = createTransitions(transitionRules);
    return (getInitialProps)=>function(context) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            const applyRedirect = (err)=>{
                const transitionArgs = [
                    err,
                    context,
                    ...args
                ];
                const dest = transition(...transitionArgs);
                if (!dest) throw err;
                return redirect(dest, context, transitionArgs);
            };
            try {
                const componentProps = safeApply(getInitialProps, context, ...args);
                return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isPromise */ .tI)(componentProps) ? componentProps.catch(applyRedirect) : componentProps;
            } catch (err) {
                return applyRedirect(err);
            }
        };
};
const reverseCondition = (param)=>{
    let [condition, fallback] = param;
    return [
        (0,_insightfulscience_shared_utils_validation__WEBPACK_IMPORTED_MODULE_3__/* .not */ .ff)(condition),
        fallback
    ];
};
const reverseConditions = (conditions)=>conditions.map(reverseCondition);
const checkPreConditions = (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(redirectIf, reverseConditions);
const checkPostConditions = (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(redirectIfProps, reverseConditions);
/** @type {<P extends {}>(Page: ConditionalPage<P>) => NextPage<P>} */ const WithConditions = (Page)=>{
    const { preConditions , postConditions , onError , getInitialProps  } = Page;
    // eslint-disable-next-line no-underscore-dangle, react/destructuring-assignment, react/prop-types
    const ConditionalPage = (props)=>props.__dontRender ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, {
            ...props
        });
    Object.assign(ConditionalPage, Page);
    delete ConditionalPage.preConditions;
    delete ConditionalPage.postConditions;
    delete ConditionalPage.onError;
    // eslint-disable-next-line no-param-reassign
    ConditionalPage.getInitialProps = (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(preConditions ? checkPreConditions(preConditions) : _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .idX */ .Yr, postConditions ? checkPostConditions(postConditions) : _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .idX */ .Yr, onError ? redirectOnError(onError) : _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .idX */ .Yr)(getInitialProps);
    return ConditionalPage;
};
/* harmony default export */ __webpack_exports__["ZP"] = (WithConditions);


/***/ })

}]);